class ShelfProductVariantController {
    constructor(config, trolleyService, analytics) {
        this.config = config;
        this.trolleyService = trolleyService;
        this.analytics = analytics;
    }

    $onInit() {
        this.defaultImagePath = this.config.DefaultProductImageSmall;
    }

    gtmProductClickDataPush() {
        this.analytics.push({ data: this.product, type: this.analytics.mapperTypes.customEvent.productClick });
    }
}

const shelfProductVariantComponentDefinition = {
    bindings: {
        product: '<',
        totalVariants: '=',
    },
    controller: ['config', 'TrolleyService', 'AnalyticsService', ShelfProductVariantController],
    template: require('./shelf-product-variant.component.html').trim(),
};

module.exports = {
    ShelfProductVariantController,
    shelfProductVariantComponentDefinition,
};



// WEBPACK FOOTER //
// ./src/shop/shelfproduct/shelf-product-variant.component.js